import { Injectable } from "@angular/core";

@Injectable({
    providedIn: "root",
})
export class ArchivoService {
    constructor() {}

    descargar(blob: Blob, filename: string) {
        const a = document.createElement("a");
        let url = window.URL.createObjectURL(blob);
        a.setAttribute("download", filename);
        a.href = url;
        a.click();
        a.remove();
    }
}
